import { put, takeEvery, call } from 'redux-saga/effects';
import Axios from 'axios';
import Actions from '../action';
import { APP_VARIABLES, DOMAIN_URL } from '@constants/app-constants';

export function* usersSetup(action) {
	const corporateId = localStorage.getItem(APP_VARIABLES.CORPORATE_ID);
	try {
		const response = {
			doc: null,
			leave: null,
		};
		yield put(Actions.creators.getSetupSuccess(response));
	} catch (err) {
		yield put(Actions.creators.getSetupFailed(err));
	}
}
export function* setupStatusUpdateServices() {
	const baseUrl = `${DOMAIN_URL}/SetupStatus`;
	const corporateId = localStorage.getItem(APP_VARIABLES.CORPORATE_ID);
	const request = {
		state: true,
	};
	try {
		const uri = `${baseUrl}/${corporateId}`;
		const res = yield call(Axios.post, uri, request);
		yield put(Actions.creators.setupStatusUpdateSuccess(res.data));
	} catch (err) {
		yield put(Actions.creators.setupStatusUpdateFail(err));
	}
}
export default function* appWatcher() {
	yield takeEvery(Actions.types.GET_SETUP, usersSetup);
	yield takeEvery(Actions.types.SETUP_STATUS_UPDATE_START, setupStatusUpdateServices);
}
